import React from 'react';
import Expander from '@sats-group/fresh-fitness-ui-lib/react/expander';
import NavigationCard from '@sats-group/fresh-fitness-ui-lib/react/navigation-card';

import ArticleCard from 'root/client/components/article-card/article-card';
import { BlockType } from 'root/shared/content-block-helpers';
import Carousel from 'root/client/components/carousel/carousel';
import ComponentList from 'root/client/components/component-list/component-list';
import ContentContainer from 'root/client/components/content-container/content-container';
import ContentElement from 'root/client/components/content-element/content-element';
import CTABanner from 'root/client/components/cta-banner/cta-banner';
import LinkCards from 'root/client/components/link-cards/link-cards';
import ProductOptionCard from 'root/client/components/product-option-card/product-option-card';
import ProductOptionCards from 'root/client/components/product-option-cards/product-option-cards';
import ProfileCardList from 'root/client/components/profile-card-list/profile-card-list';
import RichText from 'root/client/components/rich-text/rich-text';
import SplitInfoModule from 'root/client/components/split-info-module/split-info-module';
import TextBlock from 'root/client/components/text-block/text-block';

import ContentBlock from './content-block';
import type { ContentBlocks as ContentBlocksProps } from './content-blocks.types';

const ContentBlocks: React.FC<ContentBlocksProps> = ({ blocks }) => (
  <div className="content-blocks">
    <div className="content-blocks__blocks">
      {blocks.map(block => {
        switch (block.type) {
          case BlockType.ArticleCardCarousel: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <Carousel {...block.props} entryRenderer={ArticleCard} />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.ArticleCardComponentList: {
            return (
              <ContentBlock
                id={block.key}
                key={block.key}
                type={block.type}
                onFixedAlternateBackground={true}
              >
                <ContentContainer>
                  <ComponentList {...block.props} entryRenderer={ArticleCard} />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.ContentElementCarousel: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <Carousel {...block.props} entryRenderer={ContentElement} />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.ContentElementComponentList: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <ComponentList
                    {...block.props}
                    entryRenderer={ContentElement}
                  />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.CTABanner: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <CTABanner {...block.props} />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.Expander: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <Expander {...block.props} itemRenderer={RichText} />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.LinkCards: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <LinkCards {...block.props} />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.NavigationCardCarousel: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <Carousel {...block.props} entryRenderer={NavigationCard} />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.NavigationCardComponentList: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <ComponentList
                    {...block.props}
                    entryRenderer={NavigationCard}
                  />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.ProductOptionCardCarousel: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <Carousel
                    {...block.props}
                    entryRenderer={ProductOptionCard}
                  />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.ProductOptionCardComponentList: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <ComponentList
                    {...block.props}
                    entryRenderer={ProductOptionCard}
                  />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.ProfileCardList: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <ProfileCardList {...block.props} />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.SplitInfoModule: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <SplitInfoModule {...block.props} />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.TextBlock: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <TextBlock {...block.props} />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.TextBlockCarousel: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <Carousel {...block.props} entryRenderer={TextBlock} />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.TextBlockComponentList: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <ComponentList {...block.props} entryRenderer={TextBlock} />
                </ContentContainer>
              </ContentBlock>
            );
          }
          case BlockType.MembershipsBlock: {
            return (
              <ContentBlock id={block.key} key={block.key} type={block.type}>
                <ContentContainer>
                  <ProductOptionCards {...block.props} />
                </ContentContainer>
              </ContentBlock>
            );
          }
        }
      })}
    </div>
  </div>
);

export default ContentBlocks;
